// extracted by mini-css-extract-plugin
export default {"overlay":"Error_overlay__DBSLf","message":"Error_message__NbGak"};